import styled from 'styled-components';

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-right: ${({ isMobile }) => (isMobile ? '5%' : '100px')};
  padding-left: ${({ isMobile }) => (isMobile ? '5%' : '0')};
  box-shadow: 0px 8px 15px 0px rgba(0,0,0,0.05);
  height: 64px;
  background-color: ${({ theme }) => theme.white};
`

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: flex-start;
`

export const StyledAvatar = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.mocaPurple};
  object-fit: cover;
`

export const NameContainer = styled.div`
  margin-left: 12px;
  display: flex;
  flex-direction: column;
`
